import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { formatCLP, formatDateTime, apiError } from "../../lib/format";
import { toast } from "sonner";

export default function AdminLoans() {
  const [loans, setLoans] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => api.get("/loans", { params: { status: filter || undefined } }).then((r) => setLoans(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const decide = async (id, action) => {
    try { await api.post(`/loans/${id}/${action}`, { comment: "" }); toast.success("Hecho"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-8">
      <header>
        <div className="label-mono mb-2">Administración</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Todos los créditos</h1>
      </header>

      <div className="flex gap-0 border border-hairline w-fit">
        {["", "pendiente", "aprobado", "rechazado", "desembolsado", "ofrecido"].map((f) => (
          <button key={f || "all"} onClick={() => setFilter(f)} className={`h-10 px-4 text-xs font-mono uppercase tracking-widest border-r border-hairline last:border-r-0 ${filter === f ? "bg-forest text-bg" : "bg-surface hover:bg-bg"}`}>
            {f || "Todos"}
          </button>
        ))}
      </div>

      <div className="bento">
        <table className="w-full text-sm">
          <thead><tr className="label-mono border-b border-hairline">
            <th className="px-6 py-3 text-left">Fecha</th>
            <th className="px-6 py-3 text-left">Cliente</th>
            <th className="px-6 py-3 text-right">Monto</th>
            <th className="px-6 py-3 text-left">Cuotas</th>
            <th className="px-6 py-3 text-left">Estado</th>
            <th className="px-6 py-3 text-right">Acciones</th>
          </tr></thead>
          <tbody>
            {loans.length === 0 && <tr><td colSpan="6" className="p-10 text-center text-inkMuted text-sm">Sin créditos.</td></tr>}
            {loans.map((l) => (
              <tr key={l.id} className="border-b border-hairline">
                <td className="px-6 py-3 font-mono text-xs">{formatDateTime(l.created_at)}</td>
                <td className="px-6 py-3"><Link to={`/app/clientes/${l.user_id}`} className="font-semibold hover:text-forest">{l.client_name}</Link></td>
                <td className="px-6 py-3 text-right font-mono">{formatCLP(l.amount)}</td>
                <td className="px-6 py-3">{l.cuotas}</td>
                <td className="px-6 py-3 label-mono">{l.status}</td>
                <td className="px-6 py-3 text-right space-x-2">
                  {(l.status === "pendiente" || l.status === "ofrecido") && <>
                    <button onClick={() => decide(l.id, "approve")} className="h-8 px-3 bg-success text-bg text-xs">Aprobar</button>
                    <button onClick={() => decide(l.id, "reject")} className="h-8 px-3 border border-danger text-danger text-xs">Rechazar</button>
                  </>}
                  {l.status === "aprobado" && <button onClick={() => decide(l.id, "disburse")} className="h-8 px-3 bg-burnt text-bg text-xs">Desembolsar</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
